/**
 * Shared platform display-name formatter — extracted from CampaignsPage.js's
 * own `getPlatformName` (the canonical, already-correct mapping used by the
 * real campaigns table's "PLATFORM" column) so other campaigns-list-adjacent
 * UI (e.g. CopyCampaignWorkflow/CopyCampaignEntryPicker.js) formats the same
 * raw `destination` values the same way, instead of falling back to a raw
 * slug like "google-ads-pmax" when it doesn't recognize a spelling.
 */
const PLATFORM_NAMES = {
  dv360: 'DV360',
  ttd: 'The Trade Desk',
  facebook: 'Facebook',
  google_ads: 'Google Ads Search',
  google_search: 'Google Ads Search',
  'google-ads-search': 'Google Ads Search',
  'google-ads-pmax': 'Google Ads PMax',
  google_pmax: 'Google Ads PMax',
  'google-ads-demandgen': 'Google Ads DemandGen',
  google_demandgen: 'Google Ads DemandGen',
  tiktok: 'TikTok',
  madhive: 'MadHive',
};

export function getPlatformName(platform) {
  return PLATFORM_NAMES[platform?.toLowerCase()] || platform || 'N/A';
}
